/**
 * <strong>Properties:</strong><br>
 * <br>
 * <li>{@link module:mw-form/mixins/property/ArrowModeMixin|arrowMode}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/DescriptionMixin|description}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/DisabledMixin|disabled}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/HasDynamicMenuMixin|hasDynamicMenu}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/IconMixin|icon}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/IconAlignmentMixin|iconAlignment}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/MenuMixin|menu}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/TagMixin|tag}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/TextMixin|text}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/ValidationMixin|validationState, errorText, warningText}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/SizeMixin|width, height}</li>
 * <br>
 * <br>
 * <strong>Events:</strong>
 * <br>
 * <br>
 * <li>dropdownclick</li>
 * <br>
 * <br>
 * <strong>Example:</strong>
 * <br>
 * <br>
 * For a working example, see the {@link http://inside-files/dev/eps/WIT/WebWidgets/Gallery/Gallery/|gallery}
 * <br>
 * <br>
 * @module mw-form/DropDownButton
 *
 * @copyright Copyright 2015-2016 The MathWorks, Inc.
 */

// TODO: Remove _CSSStateMixin dependency, as seen in SplitButton and ToggleSplitButton

define([
    "dojo/_base/declare",

    "dijit/_WidgetBase",
    "dijit/_Contained",
    "dijit/_CssStateMixin",
    "dijit/_FocusMixin",
    "dijit/_TemplatedMixin",

    "mw-form/mixins/property/TagMixin",
    "mw-form/mixins/property/MenuMixin",
    "mw-form/mixins/property/HasDynamicMenuMixin",
    "mw-form/mixins/property/DescriptionMixin",
    "mw-form/mixins/property/DisabledMixin",
    "mw-form/mixins/property/IconAlignmentMixin",
    "mw-form/mixins/property/IconMixin",
    "mw-form/mixins/property/ArrowModeMixin",
    "mw-form/mixins/property/SizeMixin",
    "mw-form/mixins/property/TextMixin",
    "mw-form/mixins/property/VisualFamilyMixin",
    "mw-form/mixins/property/ValidationMixin",

    "mw-form/mixins/AccessibilityClickMixin",
    "mw-form/mixins/SplitTypeButtonsAriaLabelledByMixin",
    "mw-form/mixins/PreventSelectionMixin",

    "mw-form/mixins/property/DropDownButtonIconAlignmentMixin",
    "mw-form/mixins/property/DropDownButtonArrowModeMixin",
    "mw-form/mixins/property/DropDownButtonTextMixin",
    "mw-form/mixins/property/DropDownButtonSizeMixin",

    "mw-form/mixins/mixinDependencyValidator",

    "dojo/text!./templates/DropDownButton.html"
], function (declare, _WidgetBase, _Contained, _CssStateMixin, _FocusMixin, _TemplatedMixin,
             TagMixin, MenuMixin, HasDynamicMenuMixin, DescriptionMixin, DisabledMixin,
             IconAlignmentMixin, IconMixin, ArrowModeMixin, SizeMixin, TextMixin, VisualFamilyMixin,
             ValidationMixin, AccessibilityClickMixin, SplitTypeButtonsAriaLabelledByMixin, PreventSelectionMixin,
             DropDownButtonIconAlignmentMixin, DropDownButtonArrowModeMixin,
             DropDownButtonTextMixin, DropDownButtonSizeMixin, mixinDependencyValidator, template) {

    return declare(mixinDependencyValidator.validate([_WidgetBase, _Contained, _CssStateMixin, _FocusMixin, _TemplatedMixin,
        TagMixin, MenuMixin, HasDynamicMenuMixin, DescriptionMixin, DisabledMixin,
        IconAlignmentMixin, IconMixin, ArrowModeMixin, SizeMixin, TextMixin, VisualFamilyMixin,
        ValidationMixin, AccessibilityClickMixin, SplitTypeButtonsAriaLabelledByMixin, PreventSelectionMixin,
        DropDownButtonIconAlignmentMixin, DropDownButtonArrowModeMixin, DropDownButtonTextMixin, DropDownButtonSizeMixin]), {

        baseClass: "mwWidget mwDropDownButton",
        templateString: template,

        /**
         * Get the array of title nodes.
         * @returns {Array}
         */
        getTitleNodes: function() {
            return [this.focusNode];
        }
    });
});